import styled from "styled-components";
import { Layout, Menu } from "antd";
const { Sider, Header: H } = Layout;

const StyledImageHeader = styled.h2`
  padding: 15px 0px 0px 12px;
  height: 50px;
  width: 270px;
  line-height: 15px;
`;

const StyledHeader1 = styled.p`
  margin-top: 0;
  margin-bottom: 0em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 150;
  display: block;
  font-size: 3em;
`;


const StyledSearchForm = styled.div`
  margin: 0px 0px 24px 0px;
  padding: 10px 10px 20px 20px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
`;


const GeneralStyledContent = styled(Layout.Content)`
  background: white;
  margin: 5px 5px 5px 5px;
  padding: 20px 20px 10px 20px;
  min-height: ${window.innerHeight - 55}px;
`;


const StyledSider = styled(Sider)`
  padding: 0;
  max-width: 270;
  min-width: 270;
  width: 270;
`;


const StyledLogo = styled.img`
  margin-left: 22%;
  margin-top: 100px;
`;


const StyledHearder = styled(H)`
  background: #ffffffff !important;
  color: white !important;
  border-left: 1px solid #ececec;
  padding: 0px 0px px 0px;
  height: 65px !important;
`;

const MenuHeader = styled(Menu)`
  background: #ffffffff !important;
  color: white !important;
  line-height: 46px !important;
  border-bottom: none !important;
  text-align: right !important;
`


export {
  StyledHearder,
  StyledLogo,
  StyledSearchForm,
  StyledHeader1,
  GeneralStyledContent,
  StyledSider,
  StyledImageHeader,
  MenuHeader
};
